import { userConstants } from "../constants/login.constants";

function companyEmailLogs(state = {}, action) {
    switch (action.type) {
        case userConstants.COMPANYEMAILLOGS_REQUEST:
            return {
                loading: true
            };
        case userConstants.COMPANYEMAILLOGS_SUCCESS:
            return {
                items: action.companyEmailLogs
            };
        case userConstants.COMPANYEMAILLOGS_FAILURE:
            return {
                error: action.error
            };
        default:
            return state;
    }
}

export default companyEmailLogs;